<template>
    <div class="periodPickerContainer">
        <el-select
                :value="value[0]"
                @change="onBeginChange"
                :clearable="clearable"
                :disabled="disabled"
        >
            <el-option
                    :key="p.key || p.value"
                    :label="p.label"
                    :size="size"
                    :value="p.value"
                    v-for="p in options"
            ></el-option>
        </el-select>
        <span class="sep hidden-md-and-down"></span>
        <el-select
                :disabled="disabled || secondDisabled"
                :value="value[1]"
                @change="onEndChange"
                :clearable="clearable"
        >
            <el-option
                    :key="p.key || p.value"
                    :label="p.label"
                    :size="size"
                    :value="p.value"
                    v-for="p in secondPeriods"
            ></el-option>
        </el-select>
    </div>
</template>

<script>
    export default {
        name: 'PeriodPicker',
        computed: {
            secondDisabled() {
                return !this.value[0];
            },
            secondPeriods() {
                return this.options.filter(f => this.comparer(this.value[0], f.value));
            }
        },
        props: {
            separator: {
                type: String,
                default: '-'
            },
            options: {
                type: Array,
                default: () => []
            },
            comparer: {
                type: Function,
                default: () => () => true
            },
            size: {
                type: String,
                default: ''
            },
            value: {
                type: Array,
                default: () => ['', '']
            },
            clearable:{
                type: Boolean,
                default: false
            },
            disabled:{
                type: Boolean,
                default: false
            }
        },

        methods: {
            onBeginChange(val) {
                this.$emit('beginChange', val, [...this.value]);
                this.$emit('input', [val, val > this.value[1] ? '' : this.value[1]]);
            },

            onEndChange(val) {
                this.$emit('endChange', val, [...this.value]);
                this.$emit('input', [ this.value[0], val]);
            }
        }
    }
</script>

<style>
    .periodPickerContainer {
        display: inline-block;
        background-color: #fff;
        border: 1px solid rgba(200, 200, 200, 0.7);
        border-radius: 2px;
        margin: 0;
        padding: 1px;
    }

    .periodPickerContainer .el-select .el-input__inner,
    .periodPickerContainer .el-select .el-input.is-disabled .el-input__inner
    {
        border: none !important;
        border-radius: 0px;
    }

    .periodPickerContainer .sep{
        border-right: 1px rgba(200, 200, 200, 0.7) solid;
    }
</style>